import React from "react";

interface DynamicFormFieldProps {
  field: any;
  formData: Record<string, any>;
  onChange: (fieldName: string, value: any) => void;
}

export const DynamicFormField: React.FC<DynamicFormFieldProps> = ({
  field,
  formData,
  onChange,
}) => {
  const isString = typeof field === "string";
  const fieldName = isString ? field : field.name;
  const fieldType = isString ? "text" : field.type || "text";
  const fieldLabel = isString ? field : field.label || field.name;

  const isGenderField = fieldName?.toLowerCase() === "gender";
  const isSelectField = fieldType === "select";
  const isMultiSelectField = fieldType === "multiselect";
  const isFileField = fieldType === "file";
  const isDateField = fieldType === "date"; // <-- 1. Προσθήκη ελέγχου για ημερομηνία
  const isIdField =
    fieldName?.toLowerCase().endsWith("id") ||
    isGenderField ||
    fieldName === "format";

  const formatDateForInput = (val: any) => {
    if (!val) return "";
    if (typeof val === "string" && val.includes("T")) {
      return val.split("T")[0]; // Παίρνει μόνο το "2026-08-19" για τον browser
    }
    return val;
  };

  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-slate-700 capitalize">
        {fieldLabel}
      </label>

      {isMultiSelectField ? (
        <details className="relative group border rounded bg-white">
          <summary className="px-3 py-2 text-sm cursor-pointer list-none flex justify-between items-center text-slate-700 select-none">
            <span>
              {formData[fieldName]?.length > 0
                ? `Επιλέχθηκαν (${formData[fieldName].length})`
                : "Επιλέξτε..."}
            </span>
            <span className="text-xs text-slate-400">▼</span>
          </summary>
          <div className="absolute z-10 left-0 right-0 top-full mt-1 max-h-48 overflow-y-auto border rounded bg-white shadow-lg p-2 space-y-1">
            {!isString &&
              field.options?.map((opt: any) => {
                const selected = (formData[fieldName] || []).includes(
                  opt.value,
                );
                return (
                  <label
                    key={opt.value}
                    className="flex items-center gap-2 px-2 py-1 text-sm hover:bg-slate-50 rounded cursor-pointer"
                  >
                    {/* ΤΟ INPUT TYPE="DATE" ΕΦΥΓΕ ΑΠΟ ΕΔΩ, ΗΤΑΝ ΛΑΘΟΣ */}
                    <input
                      type="checkbox"
                      checked={selected}
                      onChange={(e) => {
                        const currentArr = formData[fieldName] || [];
                        const updated = e.target.checked
                          ? [...currentArr, opt.value]
                          : currentArr.filter((v: any) => v !== opt.value);
                        onChange(fieldName, updated);
                      }}
                    />
                    <span className="text-slate-700">{opt.label}</span>
                  </label>
                );
              })}
          </div>
        </details>
      ) : isFileField ? (
        <input
          type="file"
          className="border rounded px-3 py-2 text-sm bg-white"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) onChange(fieldName, file);
          }}
        />
      ) : isDateField ? (
        /* 2. ΣΩΣΤΟΣ ΧΕΙΡΙΣΜΟΣ ΓΙΑ ΗΜΕΡΟΜΗΝΙΕΣ */
        <input
          type="date"
          className="border rounded px-3 py-2 text-sm bg-white"
          value={formatDateForInput(formData[fieldName])}
          onChange={(e) => {
            onChange(fieldName, e.target.value);
          }}
        />
      ) : isSelectField ? (
        <select
          className="border rounded px-3 py-2 text-sm bg-white"
          value={formData[fieldName] ?? ""}
          onChange={(e) => {
            const val = e.target.value;
            const parsedVal = isIdField ? (val === "" ? "" : Number(val)) : val;
            onChange(fieldName, parsedVal);
          }}
        >
          <option value="">Επιλέξτε...</option>
          {!isString &&
            field.options?.map((opt: any, index: number) => (
              <option key={opt.value ?? index} value={opt.value}>
                {opt.label}
              </option>
            ))}
        </select>
      ) : isGenderField ? (
        <select
          className="border rounded px-3 py-2 text-sm bg-white"
          value={formData[fieldName] ?? ""}
          onChange={(e) =>
            onChange(
              fieldName,
              e.target.value === "" ? "" : Number(e.target.value),
            )
          }
        >
          <option value="">Επιλέξτε φύλο...</option>
          <option value={1}>Άνδρας</option>
          <option value={2}>Γυναίκα</option>
          <option value={3}>Άλλο</option>
        </select>
      ) : (
        <input
          type={fieldType}
          className="border rounded px-3 py-2 text-sm"
          value={formData[fieldName] ?? ""}
          onChange={(e) => {
            const val = e.target.value;
            const parsedVal =
              fieldType === "number" ? (val === "" ? "" : Number(val)) : val;
            onChange(fieldName, parsedVal);
          }}
        />
      )}
    </div>
  );
};
